import {
    HttpEvent,
    HttpHandler,
    HttpHeaders,
    HttpInterceptor,
    HttpRequest
} from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { ISettings, SETTINGS } from '@lsq-frontend/angular-shared/settings';
import { Observable } from 'rxjs';
import { ApiRoutes } from '@lsq-frontend/angular-shared/app-constants';
import { Serializer } from '../../services/serializer/serializer';
import { WindowReferenceService } from '../../services/window-reference/window-reference.service';

@Injectable({ providedIn: 'root' })
export class RequestInterceptor implements HttpInterceptor {
    private _cookieNamePrimary = 'XSRF-TOKEN';
    private _cookieNameSecondary = 'XSRF-TOKEN';
    private _headerName = 'X-XSRF-TOKEN';

    constructor(
        @Inject(SETTINGS) private _settings: ISettings,
        private _windowReferenceService: WindowReferenceService,
        private _serializer: Serializer
    ) {
        this._cookieNamePrimary = `${this._cookieNameSecondary}-${this._settings.applicationName}`.toUpperCase();
        if (this._settings.isDemo) {
            this._cookieNamePrimary = `${this._cookieNamePrimary}-DEMO`;
        }
    }

    public intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        if (!!request.url) {
            // Handle admin-api
            if (
                this._settings.applicationName === 'Compass' &&
                (request.url.indexOf(this._settings.httpApiServiceNameUrlMap.financing) > -1 ||
                    request.url.indexOf(this._settings.httpApiServiceNameUrlMap.financingAdmin) >
                        -1)
            ) {
                const headers = new HttpHeaders().set('Content-Type', 'application/json');
                const requestBody = {
                    endpointName: request.url.substring(request.url.lastIndexOf('/') + 1),
                    jsonRequest: this._serializer.serialize(request.body)
                };
                request = request.clone({
                    url: `${this._settings.httpApiServiceNameUrlMap.compass}/api/FinancingProxy`,
                    withCredentials: true,
                    body: requestBody,
                    headers
                });
            } else {
                request = request.clone({
                    withCredentials: true
                });
            }

            // Set CORS policy for all api requests.
            if (request.url.match(new RegExp(`\/${ApiRoutes.Api}\/`))) {
                // Set the csrf token if there is one.
                const xsrfToken =
                    this._windowReferenceService.getCookie(this._cookieNamePrimary) ||
                    this._windowReferenceService.getCookie(this._cookieNameSecondary);

                if (xsrfToken) {
                    request = request.clone({
                        headers: request.headers.set(this._headerName, xsrfToken)
                    });
                }
            }
        }

        // Map the date objects back to strings in the form that Tier 1 wants.
        if (request.body) {
            request = request.clone({
                body: this._serializer.mapDateObjectsToStrings(request.body)
            });
        }

        return next.handle(request);
    }
}
